import React from 'react';
import { STORES } from '../data/stores';
import './StoreShowcase.css';

const logoContext = require.context('../assets/store-logos', false, /\.(png|jpe?g|svg|webp)$/i);
const STORE_LOGOS = logoContext.keys().reduce((acc, key) => {
  const file = key.replace('./', '');
  const id = file.replace(/\.[^.]+$/, '');
  acc[id] = logoContext(key);
  return acc;
}, {});

export default function StoreShowcase() {
  return (
    <section className="store-showcase" id="how">
      <div className="showcase-inner">
        <div className="showcase-header">
          <span className="showcase-label mono">Supported Stores</span>
          <h2 className="showcase-title">One search. Every store.</h2>
          <p className="showcase-sub">We search across India's top electronics stores so you don't have to.</p>
        </div>

        <div className="stores-row">
          {STORES.map((store) => (
            <a
              key={store.id}
              href={store.url}
              target="_blank"
              rel="noreferrer"
              className="store-showcase-card tilt-card"
              style={{ '--sc': store.color }}
            >
              <div className="store-sc-name">{store.name}</div>
              <div className="store-sc-desc">{store.description}</div>
              <div className="store-sc-logo-wrap">
                {STORE_LOGOS[store.id] ? (
                  <img className="store-sc-logo-img" src={STORE_LOGOS[store.id]} alt={`${store.name} logo`} loading="lazy" />
                ) : (
                  <div className="store-sc-logo-fallback mono">{store.name.slice(0, 2).toUpperCase()}</div>
                )}
              </div>
            </a>
          ))}
        </div>

        <div className="how-steps">
          {[
            { n: '01', title: 'Describe your project', desc: 'Type what you want to build in plain English — as detailed or brief as you like.' },
            { n: '02', title: 'Get the full component list', desc: 'AI analyzes your project and returns every component with specs, quantities, and prices.' },
            { n: '03', title: 'Shop in one click', desc: 'Select components and open them directly in your preferred store — all at once.' },
          ].map(step => (
            <div key={step.n} className="how-step">
              <div className="step-num mono">{step.n}</div>
              <div>
                <div className="step-title">{step.title}</div>
                <div className="step-desc">{step.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
